import { Pill } from "@/components/pill/Pill";
import { useLanguage } from "@/context/language-context/LanguageContext";
import type { IQuestion } from "@/types/types";
import { useState, type FC } from "react";
import { Modal } from "../../../../../../components/modal/Modal";
import QuestionModalHeader from "./QuestionModalHeader";
import QuestionModalContent from "./QuestionModalContent";
import { useTranslate } from "@/hooks/use-translate/useTranslate";

interface IQuestionProps {
  question: IQuestion;
  num: number;
}

const Question: FC<IQuestionProps> = ({ question, num }) => {
  const { language } = useLanguage();
  const translate = useTranslate();
  const [view, setView] = useState(false);

  const handleOnView = () => {
    setView(true);
  };

  const handleOnClose = () => {
    setView(false);
  };

  return (
    <>
      <button type="button" className="" onClick={handleOnView}>
        <div className="border border-ib-gray-borders p-4 flex gap-2 rounded-sm  h-32">
          <div>
            <p className="text-md">{num}.</p>
          </div>
          <div className="flex flex-col gap-2">
            <p
              className="text-md text-left"
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {question[language]}
            </p>
            <div className="flex">
              <Pill
                icon="images"
                iconClassName="size-3"
                className="bg-ib-gray-lightest"
                label={question.images.length}
              />
            </div>
          </div>
        </div>
      </button>
      {view && (
        <Modal>
          <Modal.Header>
            <QuestionModalHeader
              close={handleOnClose}
              closed={true}
              title={translate("actionDescription", [num.toString()])}
            />
          </Modal.Header>
          <Modal.Content>
            <QuestionModalContent item={question} />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default Question;
